/**
 * @description Runtime config composable.
 * This is legacy code from Nuxt. It is used to expose runtime config to the client.
 */
export function useRuntimeConfig() {
  return {
    public: {
      appMode: import.meta.env.VITE_APP_MODE,
      env: import.meta.env.NODE_ENV,
      deployEnv: import.meta.env.VITE_DEPLOY_ENV,
      baseApiUrl: import.meta.env.VITE_BASE_API_URL,
      apiVersion: import.meta.env.VITE_API_VERSION,
      baseEventsApiUrl: import.meta.env.VITE_BASE_EVENTS_API_URL,
      googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
      adyenClientKey: import.meta.env.VITE_ADYEN_CLIENT_KEY,
      sentryDsn: import.meta.env.VITE_SENTRY_DSN,
      metaPixelId: import.meta.env.VITE_META_PIXEL_ID,
      baseMarketingSiteUrl: import.meta.env.VITE_BASE_MARKETING_SITE_URL,
      sgtmEnabled: import.meta.env.VITE_SGTM_ENABLED,
      sgtmEndpointUrl: import.meta.env.VITE_SGTM_ENDPOINT_URL,
      sgtmEventPath: import.meta.env.VITE_SGTM_EVENT_PATH
    }
  }
}
